import { redirect } from '@sveltejs/kit';
import { wrapLoadWithSentry } from '@sentry/sveltekit';
import { session } from '$lib/stores';

export const load = wrapLoadWithSentry(async function ({ parent, url, route }) {
  await parent();
  const sessionValue = session.get();
  // Redirect if logged in
  if (sessionValue.accessToken && !route.id.includes('verify-email') && !route.id.includes('confirm-email')) {
    const redirectUrl = url.searchParams.get('redirect');
    if (redirectUrl && !redirectUrl.startsWith('http')) {
      redirect(307, redirectUrl);
    } else {
      redirect(307, '/account' + url.search);
    }
  }
  return {};
});
